module.exports = __webpack_public_path__ + "img/1be7f41.jpg";